<template>
    <div class="BookingManagement" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>预约管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="开始日期">
                                    <!-- <el-select clearable v-model="queryform.space_id" placeholder="请选择">
                                        <el-option
                                            label="待审核"
                                            :value="0">
                                        </el-option>
                                    </el-select> -->
                                    <el-date-picker
                                        v-model="queryform.timeS"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="结束时间">
                                    <!-- <el-select clearable v-model="queryform.space_id" placeholder="请选择">
                                        <el-option
                                            label="待审核"
                                            :value="0">
                                        </el-option>
                                    </el-select> -->
                                    <el-date-picker
                                        v-model="queryform.timeE"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="场地">
                                    <!-- <el-select clearable v-model="queryform.space_id" placeholder="请选择">
                                        <el-option
                                            label="待审核"
                                            :value="0">
                                        </el-option>
                                    </el-select> -->
                                    <el-select v-model="queryform.space_id" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="changecompany">
                                        <el-option v-for="item in spaceData" :key="item.id" :label="item.title" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddBookingManagement">新增</el-button> -->
                         <el-button type="primary" @click="ExportBooking">导出</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <!-- fd802e -->
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column width="200" prop="transaction_id" label="订单号" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="150" prop="space_title" label="场地" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="120" prop="user_name" label="付款人" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="120" prop="contact" label="联系人" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="120" prop="mobile" label="联系电话" show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column prop="mobile" label="付款人手机号">
                    </el-table-column> -->
                    <el-table-column width="180" prop="company_name" label="公司名称">
                    </el-table-column>
                    <el-table-column width="150" align="center" prop="date" label="预定日期">
                    </el-table-column>
                    <el-table-column width="150" align="center" prop="time" label="预定时间段">
                    </el-table-column>
                    <el-table-column width="150" align="center" prop="hours" label="预定时长">
                    </el-table-column>
                    <el-table-column width="120" prop="total" align="right" label="订单金额">
                    </el-table-column>
                    <el-table-column width="120" align="right" prop="amount" label="实际付款金额">
                    </el-table-column>
                    <el-table-column width="150" align="center" prop="create_time" label="订单创建时间">
                    </el-table-column>
                    <el-table-column prop="status" width="100" align="center" label="状态">
                        <template slot-scope="scope">
                            <span v-if="Number(scope.row.status) === 0">待支付</span>
                            <span v-if="Number(scope.row.status) === 1">已支付</span>
                            <span v-if="Number(scope.row.status) === 2">已取消</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" v-show="Number(scope.row.status) === 0" @click="Agree(scope.row)">同意</el-button>
                            <el-button type="text" v-show="Number(scope.row.status) !== 2" @click="cancel(scope.row)">取消订单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-dialog :title="title" :visible.sync="BookingManagement" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="BookingManagement">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="公司名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人">
                            <el-input v-model="form.contact"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人电话" prop="tel">
                            <el-input v-model="form.tel"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人">
                            <el-input v-model="form.contact1"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人电话" prop="tel1">
                            <el-input v-model="form.tel1"></el-input>
                        </el-form-item>
                        <el-form-item label="房间号">
                            <el-input v-model="form.room"></el-input>
                        </el-form-item>
                        <el-form-item label="公司状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="停用" :value="0">
                                </el-option>
                                <el-option label="正常" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司简介" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.intro"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                        <el-form-item label="公司logo" style="display: block; width: 100%;">
                           <el-upload
                                class="upload-demo"
                                :action="http + '/Spaceorder/upload_file'"
                                :data="Uploaddata"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :on-success="SiteUploadSuccess"
                                :before-upload="SiteBeforeUpload"
                                multiple
                                :limit="1"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="BookingManagement = false">取 消</el-button>
                        <el-button type="primary" @click="SaveBookingManagement" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog> -->
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
import time from "../../../utils/time";
export default {
    name: "BookingManagement",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            spaceData: [],
            BookingManagement: false,
            form: {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                timeS: '',
                timeE: '',
                space_id: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                tel1: [
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]
            },
            confirmloding: false,
            loading: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        ExportBooking () {
            let that = this
            this.fullscreenLoading = true
            let data = {
                timeS: this.queryform.timeS,
                timeE: this.queryform.timeE,
                space_id: this.queryform.space_id,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                is_excel: 1,
                time: JSON.stringify(time.time)
            }
            this.$store.dispatch('ExportBooking', data).then(res => {
                let link = document.createElement('a')
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = '预约记录' // 下载的文件名
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.fullscreenLoading = false
            })
        },
        AddBookingManagement () {
            this.BookingManagement = true
            this.title = '新增公司'
            this.form = {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetBookingManagementList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetBookingManagementList()
        },
        GetBookingManagementList (keyword, room) {
            let data = {
                timeS: this.queryform.timeS,
                timeE: this.queryform.timeE,
                space_id: this.queryform.space_id,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('BookingManagementListShow', data).then(res => {
                // console.log(time.time)
                res.data.forEach(row => {
                    row.times = JSON.parse(row.times)
                    row.time = time.time[row.times[0]].label + '~' + time.time[row.times[row.times.length - 1]].end
                });
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: '',
                    contact: '',
                    tel: '',
                    contact1: '',
                    tel1: '',
                    remark: '',
                    img: [],
                    intro: '',
                    room: '',
                    status: 1
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                timeS: '',
                timeE: '',
                space_id: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetBookingManagementList()
        },
        handleRemove(file, fileList) {
             this.form.img = fileList
            //  console.log(fileList)
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        SiteBeforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJPG) {
                this.$message.error('只能上传jpeg或png图片！');
            }
            return isJPG;
        },
        SiteUploadSuccess(response, file, fileList) {
            this.form.img = fileList
        },
        SaveBookingManagement() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveBookingManagement', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.BookingManagement = false
                            that.fullscreenLoading = true
                            that.GetBookingManagementList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        Agree (row) {
            let data = {
                id: row.id
            }
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            this.$store.dispatch('AgreeBookingManagement', data).then(res => {
                if (res.flag) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    this.fullscreenLoading = true;
                    this.HongDian();
                    this.GetBookingManagementList();
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                };
            });
        },
        cancel (row) {
            this.$confirm('是否取消该订单？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                let data = {
                    id: row.id
                }
                data.ADMIN_ID = getAdminId();
                data.ADMIN_TOKEN = getToken();
                this.$store.dispatch('cancelBookingManagement', data).then(res => {
                    if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.fullscreenLoading = true;
                        this.HongDian();
                        this.GetBookingManagementList();
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                    };
                });
            }).catch(() => {
            })
        },
        HongDian () {
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            };
            this.$store.dispatch("Isread", data).then(res => {
                console.log(res);
            });
        },
        EditBookingManagement(row) {
            this.BookingManagement = true
            this.title = '编辑公司'
            this.form = JSON.parse(JSON.stringify(row))
            this.fileList = JSON.parse(this.form.img)
            this.form.img = JSON.parse(this.form.img)
        },
        DelBookingManagement(row) {
            this.$confirm('是否删除该公司？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelBookingManagement', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetBookingManagementList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken()
                }
                data.keyword = query
                this.$store.dispatch('GetSiteManagementListShow', data).then(res => {
                    this.spaceData = res.data
                    this.loading = false
                })
            } else {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken()
                }
                this.$store.dispatch('GetSiteManagementListShow', data).then(res => {
                    this.spaceData = res.data
                    this.loading = false
                })
            }
        },
        changecompany (e) {
        },
        GetSiteManagementList() {
            this.fullscreenLoading = true
            let data = {
                limit: 100,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('GetSiteManagementListShow', data).then(res => {
                this.spaceData = res.data
                // this.fullscreenLoading = false
                // this.total = res.something
            })
        },
    },
    created() {
        this.fullscreenLoading = true
        let date = new Date()
        let Y = date.getFullYear()
        date.setDate(1)
        let M = date.getMonth() + 1
        let D = new Date().getDate()
        if (M < 10) {
            M = '0' + M
        }
        if (D < 10) {
            D = '0' + D
        }
        this.queryform.timeS = Y + '-' + M + '-' + D
        this.queryform.timeE = Y + '-' + M + '-' + D
        this.GetSiteManagementList()
        this.GetBookingManagementList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.BookingManagement {
    width: 100%;
}
.BookingManagement .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.BookingManagement .el-header .el-row .el-col h2 {
    text-align: center;
}
.BookingManagement .el-header .el-row .el-col {
    text-align: center;
}
.BookingManagement .el-header .el-row .el-col:last-child {
    text-align: right;
}
.BookingManagement .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.BookingManagement .el-main .BookingManagement .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.BookingManagement .el-main .BookingManagement .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
}
</style>
